import type { JSX, PropsWithChildren } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { Spacing } from 'src/styles';

import { MButton } from '../MButton/MButton';
import { MTooltip } from '../MTooltip/MTooltip';

import * as Styles from './MFormSection.styles';

export interface MFormSectionProps {
  title?: string | JSX.Element;
  onEdit?: () => void;
  disabled?: boolean;
  isEditable: boolean;
  isEditMode: boolean;
  tooltip?: {
    type: 'modal' | 'popover';
    icon?: 'info' | 'question';
    title?: string;
    label?: string;
    content: string | JSX.Element;
  };
  className?: string;
  testId?: string;
}

export const MFormSection = ({
  title,
  onEdit,
  disabled,
  isEditable,
  isEditMode,
  tooltip,
  className = '',
  children,
  testId,
}: PropsWithChildren<MFormSectionProps>) => {
  return (
    <div className={cx(Styles.section, className)}>
      <Row className={title || isEditable ? Spacing.mb32 : Spacing.mb0}>
        <Col span={24} className={Styles.header(Boolean(title))}>
          {title && (
            <Col className={Styles.title} data-testid={testId + '-title'}>
              {title}
            </Col>
          )}
          {isEditable && !isEditMode && (
            <Col>
              <MButton onClick={onEdit} type='tertiary' testId={testId + '-edit-button'} disabled={disabled}>
                Edit <EditOutlined />
              </MButton>
            </Col>
          )}
        </Col>
        {tooltip && (
          <Col span={24}>
            <MTooltip
              type={tooltip.type}
              icon={tooltip.icon}
              title={tooltip.title}
              label={tooltip.label}
              testId={testId}>
              {tooltip.content}
            </MTooltip>
          </Col>
        )}
      </Row>
      <Row>{children}</Row>
    </div>
  );
};
